import request from '@/api/http.js'

console.log('平台环境', process.env.NODE_ENV)
const service = request
export default service
